import PageTab from "components/common/pageTab";
import TopImage from "components/common/topImage";

import { pageMenuTabList05 } from 'types/common';

import 'assets/css/brand.scss';

const STORE_LIST = [
  {
    name: "천호엔케어 서울 총판",
    address: "서울특별시 은평구 응암로12길 28, 1층 1호",
    img: "https://img.chunhomall.com/images/brand_site/store-section_600x400.jpg.jpg",
  },
];

function Store() {
  pageMenuTabList05[2].on = true;

  return (
    <div className="page_content">
      <TopImage imgUrl="https://img.chunhomall.com/images/brand_site/store-hero_1920x1080.jpg.jpg" imgText="매장소개" textcolor="#FFF"></TopImage>
      <PageTab props={pageMenuTabList05}></PageTab>

      <div className="container store">
        <div className="store-list">
          {STORE_LIST.map((store, i) => (
            <div className="store-item" key={i}>
              {store.img && (
                <div className="store-item-img">
                  <img src={store.img} alt={store.name} />
                </div>
              )}
              <div className="store-item-info">
                <div className="store-item-name">{store.name}</div>
                <div className="store-item-address">주소: {store.address}</div>
              </div>
            </div>
          ))}
          <div className="store-note">
            *천호엔케어는 전국 각지에 매장 오픈을 준비하고 있습니다.
          </div>
        </div>
      </div>
    </div>
  );
}

export default Store;
